import * as React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Table,
} from "reactstrap";
import BorrowedTable from "./BorrowedTable";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import ModalDailyWithdraw from "./Report/ModalReportDailyWithdraw";
import ModalReportBorrowTool from "./Report/ModalReportBorrowTool";
import ModalBorrowTable from "./TableBorrowPage/ModalBorrowTable";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import ModalDeleteBorrowTable from "./TableBorrowPage/ModalDeleteBorrowTable";


const baseURL = process.env.REACT_APP_API_CORS;
const userData = GetCookieData("userData");
const filterSubAdmin = userData?.positionSubAdmin?.map(i => i.type_sub_admin);
const user = GetCookieData("userData");
const token = GetCookieToken("userToken");

const ResorceOnline = () => {

  const user = GetCookieData("userData")
  const user_id = user.user_id
  document.title = "ทรัพยากรออนไลน์ | Flexible Time";
  const navigate = useNavigate();

  const [modalState, setModalState] = useState("");

  const [openBorrow, setOpenBorrow] = React.useState(false);

  const toggleModal = () => {
    setOpenBorrow(!openBorrow);
  };

  const [selectedReport, setSelectedReport] = useState({
    id: "1",
    name: "การเบิกจ่ายรายวัน",
  });

  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const [isActive, setIsActive] = useState("1");
  const activeSet = (param) => {
    setIsActive(param)
  }

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingPage />
      ) : (
        <FadeIn>
          <Container fluid>
            <Breadcrumbs title="หน้าหลัก" breadcrumbItem={`ทรัพยากรออนไลน์/${isActive == 1 ? "รายการยืมครุภัณฑ์" : isActive == 2 ? "รายการข้อมูลครุภัณฑ์" : isActive == 3 && "รายงานการยืมครุภัณฑ์"}`} breadcrumbText="ทรัพยากรออนไลน์"/>
            <Row>
              <Col xxl={12} xl={12} lg={12}>
                <BorrowedTable modalState={modalState} setModalState={setModalState} openBorrow={openBorrow} toggleModal={toggleModal} fromIndex={true} propFuc={activeSet}/>
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default ResorceOnline;
